export default "__VITE_ASSET__DU7DSPxL__"